import { Link } from "@inertiajs/react";
import { ArrowUpRight } from "lucide-react";
import { motion } from "motion/react";

export default function CapsCTA({ content }) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6 }}
      className="relative isolate my-20 overflow-hidden rounded-[2rem] bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-700 px-6 py-16 text-white shadow-2xl shadow-black/20 sm:px-10 sm:py-20 lg:px-16 lg:py-24"
    >
      <div className="absolute -right-24 -top-24 size-80 rounded-full bg-white/10 blur-3xl" />
      <div className="absolute -bottom-28 -left-20 size-72 rounded-full bg-red-500/10 blur-3xl" />

      <div className="relative flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
        <div className="max-w-4xl">
          <p className="text-xs font-black uppercase tracking-[0.32em] text-white/45">
            {content.eyebrow}
          </p>

          <h2 className="mt-5 text-4xl font-black uppercase leading-[0.95] tracking-[-0.04em] sm:text-6xl lg:text-7xl">
            {content.title}
          </h2>

          <p className="mt-6 max-w-2xl text-sm leading-7 text-white/60 sm:text-base">
            {content.description}
          </p>
        </div>

        <Link
          href={content.href}
          className="inline-flex min-h-14 shrink-0 items-center justify-center gap-3 rounded-full bg-white px-7 py-4 text-sm font-black uppercase text-black transition hover:-translate-y-1 hover:bg-neutral-200"
        >
          {content.label}
          <ArrowUpRight className="size-5" />
        </Link>
      </div>
    </motion.section>
  );
}